import React from "react";
import { Link } from "react-router-dom";
import '../AppsPrivacy.css'

const Speak2RollPrivacy = () => {

    const linksStyle = {
        textDecoration: 'none',
        color: 'black'
    }

    return(
        <div className='main'>
            <center>
                <h1 className='page-title'>Speak2Roll - Privacy Policy</h1>
            </center>

            <p className='text'> AR Studios built the "Speak2Roll" app as a free app. This service is provided by AR Studios at no cost and is intended for use as is. This page is used to inform the users regarding my policies with the collection, use and disclosure of personal information, if anyone decided to use my service</p>
            <p className='text'>
                <b>Logging Of Data</b>
                <br></br>
                The app stores does not store any data in the server  
            </p>
            
            <p className='text'>
                <b>Changes to This Privacy Policy</b>
                <br></br>
                I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. This policy is effective as of 20 December 2020.
            </p>
            <p className='text'>
                <b>Contact Us</b>
                <br></br>
                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at info@arstudios.org
            </p>

            <center>
                <Link to='/apps/speak2roll' style={linksStyle}>
                    <h3 className='link'>Speak2Roll</h3>
                </Link>
            </center>
        </div>
    )
}

export default Speak2RollPrivacy